"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListenerType = void 0;
var ListenerType;
exports.ListenerType = ListenerType;

(function (ListenerType) {
  ListenerType["mouse"] = "mouse";
  ListenerType["touch"] = "touch";
  ListenerType["keyboard"] = "keyboard";
})(ListenerType || (exports.ListenerType = ListenerType = {}));